export default __webpack_public_path__ + "static/media/bahamas.bd5eb791.jpg";